import { convertIdsToEntities } from '../utils';
import { EventInfo } from '../domain';
import { useUserMetadataQueryContext } from '../contexts/UserMetadataQueryContext';

export const useSubscribeEventsQuery = (event: EventInfo) => {
  const { emailListIds, channelIds, messageTypeIds } = event;
  const { allChannels, allMessageTypes, allLists, isLoading } = useUserMetadataQueryContext();

  const lists = convertIdsToEntities(emailListIds ?? [], allLists ?? []);
  const channels = convertIdsToEntities(channelIds ?? [], allChannels ?? []);
  const messageTypes = convertIdsToEntities(messageTypeIds ?? [], allMessageTypes ?? []);

  return {
    lists,
    channels,
    messageTypes,
    isLoading,
  };
};
